import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/gatsby-usage/",
          "title": "main Gatsby CLI commands"
        }}>{`A snippet`}</MDXTag>{` with main Gatsby commands`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-sh"
        }}>{`# start a development server
gatsby develop

# clean ".cache" and "public" directories
gatsby clean

# build all pages
gatsby build

# serves pages from the site build (from the directory "public")
gatsby serve
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "Main Gatsby CLI commands",
  "keywords": "Gatsby, CLI, main commands",
  "menu": "gatsby/usage"
};
    